export default __webpack_public_path__ + "static/media/ShellSelectNamrungruang.d8da6fcd.svg";